module.exports = __webpack_public_path__ + "8cc0b8e02b7c23b196bbef0d97197623.pdf";